import { REQUEST } from '@/constants/api';

import { FinanceInfoResponse, FinancialInfo } from '@/types/finance';

import { axios } from '@/api';

export const getFinancialInfo = async () => {
  const result = await axios.get<FinanceInfoResponse>(REQUEST.FINANCIAL_INFO);
  return result.data;
};

export const addFinancialInfo = async (payload: FinancialInfo[]) => {
  const result = await axios.post<string>(REQUEST.FINANCIAL_INFO, payload);
  return result.data;
};
